import { abbrNumberFilter, minVisitsFilter, percentageFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

export const TrafficShareDashboard: FC<ITableCellProps> = ({ value, row, progressBarTooltip }) => {
    const width = value ? value * 100 : 0,
        visits = row[progressBarTooltip]
            ? row[progressBarTooltip] < 5000
                ? minVisitsFilter()(row[progressBarTooltip])
                : abbrNumberFilter()(row[progressBarTooltip])
            : false,
        valuePercents = percentageFilter()(value || 0, 2) + "%";

    return <div>{valuePercents}</div>;
};
TrafficShareDashboard.displayName = "TrafficShareDashboard";
